import { OTP } from './otp.model';

export class SetRef {
  static readonly type = 'SetRef';

  constructor(public payload: OTP) {}
}
